import {
    recognizeText,
    preprocessCanvasForOcr,
    OCR_MIN_CONFIDENCE,
} from '../ocrRuntime'

// Live OCR for the /vision play surface. Tesseract is slow, so it throttles and
// shows the last read text; the busy-guard in the loop prevents overlap.
export default function createOcrDetector() {
    let canvas = null
    let lastAt = 0
    let lastText = '—'

    return {
        id: 'ocr',
        label: 'Text (OCR)',
        accent: '#8b5cf6',

        async load() {},

        async detect({ video, vw, vh, mirrored }) {
            const now = performance.now()
            if (now - lastAt < 1200 || !vw || !vh) {
                return {
                    boxes: [],
                    insights: [{ label: 'Text', value: lastText }],
                }
            }
            lastAt = now
            const W = Math.min(1280, Math.max(720, vw))
            const H = Math.round((W * vh) / vw)
            if (!canvas) canvas = document.createElement('canvas')
            if (canvas.width !== W) canvas.width = W
            if (canvas.height !== H) canvas.height = H
            const ctx = canvas.getContext('2d', { willReadFrequently: true })
            // Match the preview: when the camera is mirrored, flip the grabbed
            // frame so OCR reads text in the same orientation the user sees.
            ctx.save()
            if (mirrored) {
                ctx.translate(W, 0)
                ctx.scale(-1, 1)
            }
            ctx.drawImage(video, 0, 0, W, H)
            ctx.restore()
            preprocessCanvasForOcr(canvas)
            const res = await recognizeText(canvas)
            // Live read: show the current text and clear it when the text leaves
            // the frame, instead of freezing on the last word. Low-confidence
            // frames are treated as "nothing readable" so it doesn't spam noise.
            if (res) {
                const clean =
                    res.confidence >= OCR_MIN_CONFIDENCE
                        ? res.text.replace(/\s+/g, ' ').trim()
                        : ''
                lastText = clean ? clean.slice(0, 80) : '—'
            }
            return { boxes: [], insights: [{ label: 'Text', value: lastText }] }
        },

        reset() {
            lastText = '—'
            lastAt = 0
        },
        dispose() {
            canvas = null
        },
    }
}
